"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n  transition: all 500ms ease;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  transition: all 500ms ease;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n  ", ";\n  margin: 0 auto;\n  ", ";\n  transform: ", ";\n  transition: transform 300ms ease;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n  ", ";\n  margin: 0 auto;\n  ", ";\n  transform: ", ";\n  transition: transform 300ms ease;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  margin: ", ";\n  ", ";\n"], ["\n  align-items: center;\n  margin: ", ";\n  ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  // Hiding log in across all experiences temporarily for MA release but NOT subdomain clients\n  ", ";\n  \n  ", "\n  text-decoration: ", ";\n  font-family: ", ";\n  color: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  letter-spacing: 0.2px;\n  margin-right: 36px;\n  position: relative;\n  font-weight: ", ";\n\n  &:hover {\n    text-decoration: none;\n    color: ", ";\n  }\n\n  &:before {\n    content: \"\";\n    height: 1px;\n    bottom: -8px;\n    background-color: ", ";\n    position: absolute;\n    width: 100%;\n    visibility: hidden;\n    transform: scaleX(0);\n  }\n  &:hover:before {\n    transition: all 0.1s ease-out;\n    visibility: visible;\n    transform: scaleX(1);\n  }\n"], ["\n  ", ";\n  // Hiding log in across all experiences temporarily for MA release but NOT subdomain clients\n  ", ";\n  \n  ", "\n  text-decoration: ", ";\n  font-family: ", ";\n  color: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  letter-spacing: 0.2px;\n  margin-right: 36px;\n  position: relative;\n  font-weight: ", ";\n\n  &:hover {\n    text-decoration: none;\n    color: ", ";\n  }\n\n  &:before {\n    content: \"\";\n    height: 1px;\n    bottom: -8px;\n    background-color: ", ";\n    position: absolute;\n    width: 100%;\n    visibility: hidden;\n    transform: scaleX(0);\n  }\n  &:hover:before {\n    transition: all 0.1s ease-out;\n    visibility: visible;\n    transform: scaleX(1);\n  }\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n      display: none;\n    "], ["\n      display: none;\n    "]),
    _templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n"], ["\n  display: flex;\n  ", ";\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  transition: all 300ms ease;\n  ", ";\n"], ["\n  transition: all 300ms ease;\n  ", ";\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
    _templateObject12 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0.2px;\n  color: ", ";\n  ", ";\n"], ["\n  font-weight: ", ";\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0.2px;\n  color: ", ";\n  ", ";\n"]),
    _templateObject13 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 1px;\n  min-width: 1px;\n  background-color: ", ";\n  ", ";\n"], ["\n  height: 100%;\n  width: 1px;\n  min-width: 1px;\n  background-color: ", ";\n  ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyBurger = require("buoy-burger");

var _buoyBurger2 = _interopRequireDefault(_buoyBurger);

var _buoyButton = require("buoy-button");

var _buoyTheme = require("buoy-theme");

var _PoweredBy = require("./PoweredBy");

var _PoweredBy2 = _interopRequireDefault(_PoweredBy);

var _buoyAlert = require("buoy-alert");

var _buoyAlert2 = _interopRequireDefault(_buoyAlert);

var _buoyDropdown = require("buoy-dropdown");

var _buoyDropdown2 = _interopRequireDefault(_buoyDropdown);

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.nav.withConfig({
  displayName: "NavBar__Container",
  componentId: "sc-12kfkfi-0"
})(_templateObject, function (props) {
  return props.color ? props.color : _buoyTheme.colors.white(props);
}, function (props) {
  return props.boxShadow ? _buoyTheme.constants.boxShadow : "none";
});

var Nav = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__Nav",
  componentId: "sc-12kfkfi-1"
})(_templateObject2, (0, _buoyTheme.responsive)("padding", "0 20px", "0 20px", "0 20px", "0 20px", "0 16px"), (0, _buoyTheme.responsive)("max-width", "1240px", "1240px", "1240px", "1240px", "1232px"), function (props) {
  return props.boxShadow ? (0, _buoyTheme.responsive)("height", "67px", "67px", "59px", "59px", "56px") : (0, _buoyTheme.responsive)("height", "59px", "59px", "52px", "52px", "50px");
}, function (props) {
  return props.transform ? props.transform : "translateY(0)";
});

var TopNavLinksContainer = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__TopNavLinksContainer",
  componentId: "sc-12kfkfi-2"
})(_templateObject3, function (props) {
  return props.enableLanguageSelection ? "0 16px 0 0" : "0 18px 0 auto";
}, function (props) {
  return props.path.includes("symptom-checker") && props.brand == "public" ? (0, _buoyTheme.responsive)("display", "flex", "flex", "flex", "flex", "flex") : (0, _buoyTheme.responsive)("display", "flex", "flex", "flex", "none", "none");
});

var CTAContainer = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__CTAContainer",
  componentId: "sc-12kfkfi-3"
})(_templateObject4, (0, _buoyTheme.responsive)("margin-left", "none", "none", "none", "auto", "auto"));
var DropdownWrapper = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__DropdownWrapper",
  componentId: "sc-12kfkfi-4"
})(_templateObject5);

var BurgerWrapper = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__BurgerWrapper",
  componentId: "sc-12kfkfi-5"
})(_templateObject6, function (props) {
  return props.mobileOnly && (0, _buoyTheme.responsive)("display", "none", "none", "none", "flex", "flex");
});

var StyledLink = _styledComponents2.default.a.withConfig({
  displayName: "NavBar__StyledLink",
  componentId: "sc-12kfkfi-6"
})(_templateObject7, function (props) {
  return props.link.text === "Businesses" && props.isConfiguredExperience ? "display: none" : (0, _buoyTheme.responsive)("display", "inherit", "inherit", "inherit", "inherit", "none");
}, function (props) {
  return props.link.text === "Log in / Sign up" && (props.brand === "public" || props.isConfiguredExperience) && (0, _styledComponents.css)(_templateObject8);
}, function (props) {
  return (0, _buoyTheme.fontSize)(props.small ? "bodyMain" : "bodyLarge")(props);
}, function (props) {
  return props.underline ? "underline" : "none";
}, _buoyTheme.fontFamily, function (props) {
  return props.color || _buoyTheme.colors.landingBlue(props);
}, _buoyTheme.fontWeight.regular, function (props) {
  return props.color || _buoyTheme.colors.landingBlue(props);
}, function (props) {
  return props.underlineColor || _buoyTheme.colors.primary(props);
});

var LogoWrapper = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__LogoWrapper",
  componentId: "sc-12kfkfi-7"
})(_templateObject9, function (props) {
  return props.desktopOnly && (0, _buoyTheme.responsive)("display", "flex", "flex", "none", "none", "none");
});

var getLogoSize = function getLogoSize(props) {
  if (props.size === "big") {
    return (0, _buoyTheme.responsive)("height", "47px", "47px", "39px", "39px", "36px");
  } else if (props.secondary) {
    return (0, _buoyTheme.responsive)("height", "36px", "36px", "28px", "28px", "24px");
  }
  return (0, _buoyTheme.responsive)("height", "39px", "39px", "32px", "32px", "30px");
};

var Logo = _styledComponents2.default.img.withConfig({
  displayName: "NavBar__Logo",
  componentId: "sc-12kfkfi-8"
})(_templateObject10, function (props) {
  return getLogoSize(props);
});

var LogoLink = _styledComponents2.default.a.withConfig({
  displayName: "NavBar__LogoLink",
  componentId: "sc-12kfkfi-9"
})(_templateObject11);

var MessageText = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__MessageText",
  componentId: "sc-12kfkfi-10"
})(_templateObject12, _buoyTheme.fontWeight.regular, function (props) {
  return props.color || _buoyTheme.colors.primary(props);
}, (0, _buoyTheme.responsive)("display", "none", "none", "inherit", "inherit", "inherit"));

var LogoDivider = _styledComponents2.default.div.withConfig({
  displayName: "NavBar__LogoDivider",
  componentId: "sc-12kfkfi-11"
})(_templateObject13, _buoyTheme.colors.neutralLight, (0, _buoyTheme.responsive)("margin", "0px 20px", "0px 20px", "0px 16px", "0px 16px", "0px 10px"));

var NavLink = function NavLink(_ref) {
  var color = _ref.color,
      link = _ref.link,
      underlineColor = _ref.underlineColor,
      onClick = _ref.onClick,
      isConfiguredExperience = _ref.isConfiguredExperience,
      brand = _ref.brand;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    link.type === "link" && _react2.default.createElement(
      StyledLink,
      {
        tabIndex: "0",
        color: color,
        underlineColor: underlineColor,
        key: link.url,
        href: link.disabled ? null : link.href,
        underline: false,
        small: true,
        link: link,
        onClick: onClick,
        isConfiguredExperience: isConfiguredExperience,
        brand: brand
      },
      link.text && _react2.default.createElement(_reactIntl.FormattedMessage, { id: "nav.links.auth", defaultMessage: link.text })
    ),
    link.type === "button" && _react2.default.createElement(
      _buoyButton.LinkButton,
      {
        color: "primary",
        ghost: link.ghost,
        href: link.disabled ? null : link.href
      },
      link.text
    )
  );
};

var TopNav = function (_React$Component) {
  _inherits(TopNav, _React$Component);

  function TopNav() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, TopNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TopNav.__proto__ || Object.getPrototypeOf(TopNav)).call.apply(_ref2, [this].concat(args))), _this), _this.onLinkClick = function (href, onClick, newTab) {
      return function (e) {
        e.preventDefault();

        if (onClick) {
          onClick();
        } else if (newTab) {
          window.open(href, "_blank");
        } else {
          if (typeof window !== "undefined") {
            window.location = href;
            if (window.location.hash) {
              _this.props.onToggle();
            }
          }
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TopNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          message = _props.message,
          logo = _props.logo,
          links = _props.links,
          onBurgerClick = _props.onBurgerClick,
          burgerColor = _props.burgerColor,
          linkColor = _props.linkColor,
          linkUnderlineColor = _props.linkUnderlineColor,
          ghostButton = _props.ghostButton,
          showPoweredBy = _props.showPoweredBy,
          poweredByColor = _props.poweredByColor,
          poweredByUrl = _props.poweredByUrl,
          secondaryLogo = _props.secondaryLogo,
          showDesktopBurger = _props.showDesktopBurger,
          cta = _props.cta,
          baseUrl = _props.baseUrl,
          alertVariant = _props.alertVariant,
          onAlertClose = _props.onAlertClose,
          showAlertBanner = _props.showAlertBanner,
          brand = _props.brand,
          enableLanguageSelection = _props.enableLanguageSelection,
          languageOnChange = _props.languageOnChange,
          selectedLanguage = _props.selectedLanguage,
          isConfiguredExperience = _props.isConfiguredExperience,
          landing = _props.landing,
          showLanguageModal = _props.showLanguageModal,
          shouldFocusDropdown = _props.shouldFocusDropdown,
          setFocus = _props.setFocus;


      var path = typeof window !== "undefined" ? window.location.pathname.slice(1, window.location.pathname.length - 1) : "";
      // path is = iframe.htm on storybook. This conditional is to make sure path is correct while testing on storybook
      if (path === "iframe.htm") {
        baseUrl.includes("symptom-checker") ? path = "symptom-checker" : null;
      }
      // language options here for now
      var langOptions = [{
        value: "en-us",
        text: "English - US"
      }, {
        value: "es-us",
        text: "Español - US"
      }, {
        value: "ht",
        text: "Kreyòl Ayisyen"
      }, {
        value: "zh",
        text: "简体中文"
      }, {
        value: "pt",
        text: "Português"
      }, {
        value: "vi",
        text: "Tiếng Việt"
      }];

      var setLangDropdownPlaceholder = function setLangDropdownPlaceholder(lang) {
        // Fallback to en-us if unsupported lang selected
        if (lang === "es-us") return "ES - US";else return "EN - US";
      };
      var handleLogoClick = function handleLogoClick(event, brand, isConfiguredExperience) {
        // NOTE: temporary fix to problem where a user is taken out of configured experience on logo click
        // prevent going to link and instead reload page for now on /symptom-checker only
        if ((brand === "public" || isConfiguredExperience) && path === "symptom-checker") {
          event.preventDefault();
          window.location.reload();
        }
      };

      return _react2.default.createElement(
        Container,
        this.props,
        showAlertBanner && _react2.default.createElement(_buoyAlert2.default, {
          topBanner: true,
          variant: alertVariant,
          onAlertClose: onAlertClose,
          selectedLanguage: selectedLanguage,
          landing: landing
        }),
        _react2.default.createElement(
          Nav,
          this.props,
          _react2.default.createElement(
            LogoWrapper,
            null,
            logo && _react2.default.createElement(
              LogoLink,
              {
                href: logo.url,
                desktopOnly: Boolean(message),
                onClick: function onClick() {
                  return handleLogoClick(event, brand, isConfiguredExperience);
                }
              },
              _react2.default.createElement(Logo, {
                alt: logo.text || "Buoy Health logo - navigate to Buoy home page",
                src: logo.src,
                size: logo.size
              }),
              secondaryLogo && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(LogoDivider, null),
                _react2.default.createElement(Logo, {
                  secondary: true,
                  alt: secondaryLogo.text || "",
                  src: secondaryLogo.src,
                  size: secondaryLogo.size
                })
              )
            ),
            showPoweredBy && _react2.default.createElement(_PoweredBy2.default, {
              small: Boolean(logo),
              color: poweredByColor,
              desktopOnly: Boolean(message),
              url: poweredByUrl
            }),
            message && _react2.default.createElement(
              MessageText,
              null,
              message
            )
          ),
          _react2.default.createElement(
            DropdownWrapper,
            null,
            enableLanguageSelection && path === "symptom-checker" && _react2.default.createElement(_buoyDropdown2.default, {
              languageSelector: true,
              languageOnChange: languageOnChange,
              width: "100px",
              options: !(brand === "ma-gov" || brand === "massachusetts") ? langOptions.filter(function (lang) {
                return lang.value === "en-us" || lang.value === "es-us";
              }) : langOptions,
              placeholder: setLangDropdownPlaceholder(selectedLanguage) || "EN - US",
              ariaLabel: "Language selector",
              languageModalClosed: !showLanguageModal,
              shouldFocus: shouldFocusDropdown,
              setFocus: setFocus
            })
          ),
          _react2.default.createElement(
            TopNavLinksContainer,
            _extends({}, this.props, { path: path }),
            links.map(function (link, i) {
              return _react2.default.createElement(NavLink, {
                ghost: ghostButton,
                color: linkColor,
                underlineColor: linkUnderlineColor,
                key: i,
                link: link,
                onClick: link.disabled ? null : _this2.onLinkClick(link.href, link.onClick, link.newTab),
                isConfiguredExperience: isConfiguredExperience,
                brand: brand
              });
            })
          ),
          cta && path !== "symptom-checker" && _react2.default.createElement(
            CTAContainer,
            null,
            _react2.default.createElement(
              _buoyButton.LinkButton,
              {
                color: "primary",
                ghost: ghostButton,
                key: cta.url,
                href: cta.href,
                margin: "0 18px 0 0"
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "nav.links.assistant",
                defaultMessage: cta.text
              })
            )
          ),
          _react2.default.createElement(
            BurgerWrapper,
            { mobileOnly: links.length > 0 && !showDesktopBurger },
            _react2.default.createElement(_buoyBurger2.default, { onClick: onBurgerClick, color: burgerColor })
          )
        )
      );
    }
  }]);

  return TopNav;
}(_react2.default.Component);

exports.default = TopNav;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-universal-nav/dist/components/NavBar.js
// module id = 459
// module chunks = 168707334958949